import BinaryPve from './BinaryPve';
import gameRule from './gameRule';

BinaryPve.gameRule = gameRule;

export default BinaryPve;



// WEBPACK FOOTER //
// ./src/games/BinaryPve/index.js